/**
 * Javascript that must be run on every page of Century21
 * TODO: IDs for all site-wide elements that need events attached
 */
define(['jquery', 'c21', 'c21/cookie', 'c21/ajax'], function ($, c21, cookie, ajax) {
   "use strict";

   var m_jHeader,
      m_jFooter,
      m_jModalWindow,

      /**
       * Get an element from the footer
       * @param strSelector  the jQuery selector
       * @return jQuery object
       */
      getFooter = function (strSelector) {
         return m_jFooter.find(strSelector);
      },

      /**
       * Get an element from the header
       * @param strSelector  the jQuery selector
       * @return jQuery object
       */
      getHeader = function (strSelector) {
         return m_jHeader.find(strSelector);
      },

      /**
       * Set the Main Search Text
       * 
       */
      setMainSearchText = function () {
         //Set the search string cookie      
         var lastsearch = $("#lastSearchText").val();
         if (lastsearch && lastsearch.length > 0) {
            //alert(lastsearch);
            cookie.set("LAST_SEARCH_STRING", lastsearch);
            $("#searchText").val(lastsearch);
            $("#behindSearchText").val(lastsearch);
            $("#headerSearchInput").val(lastsearch);
         } else {
            lastsearch = cookie.get("LAST_SEARCH_STRING");
            $("#headerSearchInput").val(lastsearch);
         }
      },

      /**
       * Initialize the Mapping view footer.
       * 
       */
      initLiquidViewFooter = function () {
         m_jFooter = $("#liquidFooter");

         getFooter(".liquidFooterLink.privacy").on("click", function () {
            $("#dynamicSEOFooter").hide();
            getFooter(".footerFlyout.privacy").show();
            getFooter(".footerFlyout.getInTouch").hide();
         });
         getFooter(".liquidFooterLink.seoFooter").on("click", function () {
            $("#dynamicSEOFooter").show();
            getFooter(".footerFlyout.privacy").hide();
            getFooter(".footerFlyout.getInTouch").hide();
         });
         getFooter(".liquidFooterLink.getInTouch").on("click", function () {
            $("#dynamicSEOFooter").hide();
            getFooter(".footerFlyout.getInTouch").show();
            getFooter(".footerFlyout.privacy").hide();
         });
         getFooter(".footerFlyout.privacy .flyoutClose").on("click", function () {
            getFooter(".footerFlyout.privacy").hide();
         });
         getFooter(".footerFlyout.getInTouch .flyoutClose").on("click", function () {
            getFooter(".footerFlyout.getInTouch").hide();
         });
      },

      m_jLastPinnedFlyout,
      m_jLastPinnedNav,
      addHover = function (strNav, strFlyout) {
         var iTimeout,
            jNav = $(strNav),
            bTouchscreen = c21.isTouchscreen(),
            cancelAnimation = function () {
               clearTimeout(iTimeout);
            },
            bOpen = false,
            close = function () {
               jNav.removeClass("hover");
               getHeader(strFlyout).hide();
               bOpen = false;
            },
            open = function () {
               getHeader(strFlyout).slideDown();
               bOpen = true;
            },
            startAnimation = function () {
               cancelAnimation();
               iTimeout = setTimeout(close, 150);
            };

         if (bTouchscreen) {
            jNav.on("touchclick", function (e) {
               var jFlyout = getHeader(strFlyout),
                  bPinned = jFlyout.data("pinned");

               // The links should not actually go anywhere, per AF
               e.preventDefault();

               if (m_jLastPinnedFlyout) {
                  m_jLastPinnedFlyout.hide();
                  m_jLastPinnedFlyout.data("pinned", false);
                  m_jLastPinnedNav.removeClass("hover");
               }

               if (!bPinned) {
                  jFlyout.show();
                  jFlyout.data("pinned", true);
                  jNav.addClass("hover");
               }

               m_jLastPinnedFlyout = jFlyout;
               m_jLastPinnedNav = jNav;
            });
         } else {
            jNav.on({
               click: function () {
                  if (bOpen) {
                     close();
                  } else {
                     open();
                  }
               },
               mouseenter: function () {
                  getHeader(strFlyout)
                     .off("mouseleave.hover mouseenter.hover")
                     .on({
                        "mouseleave.hover": function () {
                           startAnimation();
                        },
                        "mouseenter.hover": function () {
                           cancelAnimation();
                        }
                     });

                  open();
                  jNav.addClass("hover");
                  clearTimeout(iTimeout);
               },
               mouseleave: function () {
                  startAnimation();
               }
            });
         }
      },

      /**
       * Initialize the portal header
       * 
       */
      initPortalHeader = function () {
         m_jHeader = $("#headerContainer");

         addHover("#mainNavTools", ".megaDropDown.tools");
         addHover("#mainNavAdvice", ".megaDropDown.advice");
         addHover("#mainNavAbout", ".megaDropDown.about");
         addHover("#mainNavJoin", ".megaDropDown.join");
         addHover("#mainNavContact", ".megaDropDown.contact");
      },

      getPageType = function () {
         if (!window.viewEngineName) {
            var strBodyId = $(document.body).attr("id");
            window.viewEngineName = strBodyId;
            // Possibilities:
            // contentViewEngine
            // homePageViewEngine
            // mappingViewEngine
            // adpViewEngine
            // odpViewEngine
            // pdpViewEngine
         }

         return window.viewEngineName;
      },

      /**
       * Initialize the detail page specific footer
       * 
       */
      initializeDetailFooter = function () {
         $("#footerWidgetWrapper .expandoContainer").each(function (i, el) {
            var jContainer = $(el),
               jAnchor = jContainer.find("a"),
               jItems = jContainer.parent().find('div');

            // Remove the last item (expandoContainer)
            jItems.splice(-1, 1);

            if (jItems.length > 5) {
               var jHideItems = jItems.slice(-1 * (jItems.length - 5)),
                  bHidden = true;

               jHideItems.hide().find('a').css({ color: '#f3f3f3' });
               jContainer.show();

               jAnchor.on("click", function (event) {
                  event.preventDefault();
                  bHidden = !bHidden;

                  if (bHidden) {
                     jAnchor.text('Show More');
                     jAnchor.attr("title", "Show More");
                     jHideItems.find('a').animate({ color: '#f3f3f3' }, 300);
                     setTimeout(function () {
                        jHideItems.slideUp();
                     }, 300);
                  } else {
                     jAnchor.text('Hide');
                     jAnchor.attr("title", "Hide");
                     jHideItems.slideDown(300);
                     setTimeout(function () {
                        jHideItems.find('a').animate({ color: '#898989' }, 300, function () {
                           $(this).css({ color: '' });
                        });
                     }, 300);
                  }
               });
            }
         });
      },

      /**
       * Perform GEO IP Search
       * 
       */
      doGeoIPSearch = function (searchtype) {

         //Get the last location
         //var paramname = "lid";
         var lastLocationLID = cookie.get("LAST_LOCATION");
         if (lastLocationLID === null) {
            lastLocationLID = "";
         }

         //var clientip = "74.125.224.240";  //www.google.com test case       
         //var clientip = "159.53.84.126";  //www.chase.com test case
         var clientip = "";

         ajax.doViewEngineAjax(
            'geoipsearch',
            "/geoip.c21",
            $.param({
               type: searchtype,
               lid: lastLocationLID,
               ipaddress: clientip,
               submitted: true
            }),
            {
               cache: false
            }
         );
      },

      /*
      initBackgroundStretcher = function () {
         var sCss = $("body").css("background-image"),
            sImage = sCss.replace(/"/g, "").replace(/url\(|\)$/ig, "");

         $("body").css("background", "none");
         $(document).bgStretcher({
            images: [sImage],
            imageWidth: 2100,
            imageHeight: 1200,
            slideShow: false,
            resizeProportionally: true
         });
      },
      */

      resizeModal = function () {
         if (m_jModalWindow && m_jModalWindow.children().length > 0) {
            var jWindow = $(window),
               jContainer = $("#modalContainer"),
               jBody = $("#modalShadowWrapper"),
               bAutoMaxHeight = jBody.hasClass("autoMaxHeight");
            var iBodyHeight = jContainer.height() - jBody.height() + jBody.innerHeight(),
               iWindowHeight = jWindow.height();
            if (bAutoMaxHeight) {
               jBody.css("height", (iWindowHeight - 96) + "px");
               jContainer.css("top", "5px");
            } else {
               if ((iBodyHeight + 10) > iWindowHeight) {
                  jBody.css("max-height", (iWindowHeight - 96) + "px");
                  jContainer.css("top", "5px");
               } else {
                  jBody.css("max-height", "");
                  jContainer.css("top", ((iWindowHeight - iBodyHeight) / 2) + "px");
               }
            }
            jContainer.trigger('modalResize');
         }
      },

      initializeModalWindow = function () {
         m_jModalWindow = $("#modalWindow");
         ajax.bindLoadEvent(m_jModalWindow, function () {
            resizeModal();
         });
      },

      onDomReady = function () {
         initPortalHeader();
         initLiquidViewFooter();
         getPageType();

         $(window).on('resize', function () {
            resizeModal();
         });

         initializeModalWindow();

         /*
         switch (window.viewEngineName) {
         case "homePageViewEngine":
            search.createSearchField();
            initBackgroundStretcher();
            break;

         case "mappingViewEngine":
            search.createHiddenSearchField();
            maps.initialize();
            break;

         case "pdpViewEngine":
            initializeDetailFooter();
            search.createHiddenSearchField();
            initBackgroundStretcher();
            break;

         case "adpViewEngine":
            initializeDetailFooter();
            search.createHiddenSearchField();
            initBackgroundStretcher();
            break;

         case "odpViewEngine":
            initializeDetailFooter();
            search.createHiddenSearchField();
            initBackgroundStretcher();
            break;

         default:
            search.createHiddenSearchField();
            initBackgroundStretcher();
         }
         */

         ajax.doHashTest();
      };

   $(document).ready(onDomReady);

   return {
      getPageType: getPageType,
      doGeoIPSearch: doGeoIPSearch,
      setMainSearchText: setMainSearchText,
      initializeDetailFooter: initializeDetailFooter
   };
});
